import React from 'react';
import {Outlet} from 'react-router-dom';

const Users: React.FC = () => {
  return <Outlet />;
};

export default Users;
